import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["role", "atomic", "children", "aria-live"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import Box from 'components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
var Status = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$role = props.role,
    role = _props$role === void 0 ? 'status' : _props$role,
    atomic = props.atomic,
    children = props.children,
    ariaLive = props['aria-live'],
    otherProps = _objectWithoutProperties(props, _excluded);
  var ariaLiveDefault = role === 'alert' ? 'assertive' : 'polite';
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    ref: ref,
    role: role,
    "aria-live": ariaLive || ariaLiveDefault,
    "aria-atomic": atomic ? 'true' : props['aria-atomic']
  }, otherProps), {}, {
    children: children
  }));
});
Status.displayName = 'Status';
export default Status;